import { Assessment, Folder, Hub, ViewInAr } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { TOOLTIP_PROPS } from "./internalToolsUtils";
import { CUSTOMER_CONTEXT_LINKS } from "./CUSTOMER_CONTEXT_LINKS";
import { useCustomersList } from "pages/CustomerTilesPage/useCustomersQuery";
import { useAuth0 } from "@auth0/auth0-react";

export function VisitCustomerContextPageLink({ ckey }: { ckey: string }) {
  const customerContextPageLink = CUSTOMER_CONTEXT_LINKS[ckey]?.hubspotPageUrl;
  return (
    <Tooltip title={`↗ HubSpot`} {...TOOLTIP_PROPS}>
      <IconButton
        style={
          !customerContextPageLink ? { opacity: 0.2, cursor: "default" } : {}
        }
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          if (customerContextPageLink) {
            window.open(customerContextPageLink, "_blank");
          }
        }}
      >
        <Hub />
      </IconButton>
    </Tooltip>
  );
}
export function VisitCustomerGDrivePageLink({ ckey }: { ckey: string }) {
  const [customersList] = useCustomersList();
  const { user } = useAuth0();
  const customerName =
    customersList.find(customer => customer.abbrevName === ckey)
      ?.customerName ?? ckey;
  const parsed = customerName.replaceAll("-", " ");
  const url = `https://drive.google.com/drive/u/0/search?q=${parsed}&authuser=${user?.["https://raven.ai/email"]}`;
  return (
    <Tooltip title={`↗ Customer Folder`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          window.open(url, "_blank");
        }}
      >
        <Folder />
      </IconButton>
    </Tooltip>
  );
}
export function VisitCustomerSlackReportsPageLink({ ckey }: { ckey: string }) {
  const url = `https://raventelemetry.slack.com/app_redirect?channel=reports-${ckey}`;
  return (
    <Tooltip title={`↗ reports-${ckey} Slack channel`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          window.open(url, "_blank");
        }}
      >
        <Assessment />
      </IconButton>
    </Tooltip>
  );
}

export function VisitCustomerGKEWorkloadsPageLink({ ckey }: { ckey: string }) {
  const customerGKEWorkloadsPageLink = `https://console.cloud.google.com/kubernetes/workload/overview?project=raven-cloud-1&pageState=(%22workload_list_table%22:(%22f%22:%22%255B%257B_22k_22_3A_22Is%2520system%2520object_22_2C_22t_22_3A11_2C_22v_22_3A_22_5C_22False_~*false_5C_22_22_2C_22i_22_3A_22is_system_22%257D%255D%22),%22savedViews%22:(%22i%22:%2280ea108ea84145eea490bea6fcae3e3c%22,%22c%22:%5B%5D,%22n%22:%5B%22customer-${ckey}%22%5D))&pli=1&authuser=1`;
  return (
    <Tooltip title={`↗ Workloads (GKE)`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          if (customerGKEWorkloadsPageLink) {
            window.open(customerGKEWorkloadsPageLink, "_blank");
          }
        }}
      >
        <ViewInAr />
      </IconButton>
    </Tooltip>
  );
}
